import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import DiscourseAttachDocument from './DiscourseAttachDocument';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	patientId: string;
}

const DiscourseAttachDocumentModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.discourseAttachDocumentModal.title'
			{...props}
			size={Size.FULLSCREEN}>
			<DiscourseAttachDocument patientId={props.patientId} />
		</BaseModal>
	);
};

export default DiscourseAttachDocumentModal;
